import {
    OPTED_IN,
    PENDING,
    ENABLED,
    DISABLED,
    CANCELED,
} from '@perpay-web/fintech/constants/featureEnrollmentStatuses';
import {
    CARD,
    getIsPerpayPlusVersion,
} from '@perpay-web/fintech/constants/featureTypes';
import { PERPAY_PLUS_SOLO } from '@perpay-web/fintech/constants/featureTypes';
import { FEATURES } from '@perpay-web/fintech/constants/tableNames';

export const getIsPerpayPlusEligibleAndNotOptedIn = (state) => {
    const activeStatuses = [OPTED_IN, PENDING, ENABLED, DISABLED];
    const featureEntities = state.entities[FEATURES];
    const perpayPlusUuids = Object.keys(featureEntities).filter((uuid) =>
        getIsPerpayPlusVersion(featureEntities[uuid].type),
    );
    const hasActiveEnrollment = perpayPlusUuids.some((uuid) =>
        activeStatuses.includes(featureEntities[uuid].enrollmentStatus),
    );
    if (hasActiveEnrollment) {
        return false;
    }
    const notEnrolledInSolo = perpayPlusUuids.some(
        (uuid) =>
            featureEntities[uuid].type === PERPAY_PLUS_SOLO &&
            featureEntities[uuid].enrollmentStatus === null,
    );
    return notEnrolledInSolo;
};

export const getCardFeatureDetails = (state) => {
    const cardFeatureUuid = Object.keys(state.entities[FEATURES]).filter(
        (uuid) => state.entities[FEATURES][uuid].type === CARD,
    )[0];
    const cardFeature = state.entities[FEATURES][cardFeatureUuid];

    if (!cardFeature) {
        return [];
    }

    return cardFeature.featureDetails;
};
export const getHasPerpayPlusSoloEnrollment = (state) => {
    const soloEnrollment = Object.keys(state.entities[FEATURES])
        .filter(
            (uuid) =>
                state.entities[FEATURES][uuid].type === PERPAY_PLUS_SOLO &&
                state.entities[FEATURES][uuid].enrollmentStatus !== CANCELED,
        )
        .map((uuid) => state.entities[FEATURES][uuid]);
    return soloEnrollment.length > 0;
};
